var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-benefits" }, [
    _c(
      "div",
      { staticClass: "customer-benefits--items" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { md: "4" } }, [
              _c(
                "div",
                { staticClass: "customer-benefits--items-column" },
                [
                  _c("Item", {
                    attrs: {
                      title: "Nur 1x",
                      text: _vm.oneTimeText,
                      color: "purple"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { md: "4" } }, [
              _c(
                "div",
                { staticClass: "customer-benefits--items-column" },
                [
                  _c("Item", {
                    attrs: {
                      title:
                        "Erhalte nur noch passende Vorschläge und entscheide!",
                      text:
                        "Du musst nicht dauernd suchen, sondern stelle die Job-Filter ein, wie du möchtest! skilldoo informiert dich genau dann, wenn es einen Best-Match gibt.",
                      color: "turquoise"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { md: "4" } }, [
              _c(
                "div",
                { staticClass: "customer-benefits--items-column" },
                [
                  _c("Item", {
                    attrs: {
                      title: "Niemand erfährt, dass Du es bist!",
                      text:
                        "Denn deine Jobvisitenkarte ist anonym.<br/>Erst wenn dir ein Arbeitgeber seine Daten offenlegt, entscheidest Du, ob du deinen Namen und persönlichen Daten hergibst.",
                      color: "gold"
                    }
                  })
                ],
                1
              )
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }